import Axios from 'axios'

var request = Axios.create({
  baseURL: process.env.VUE_APP_BASEURL,
  timeout: 100000
})

var http = (url, data) => {
  return new Promise((resolve, reject)=>{
    request.post(url, data).then(res => {
      if(res.data.messageLevel == 1 || res.data.messageLevel == 2){
        resolve(res.data)
      }else{
        reject(res.data)
      }
    }).catch(err => {
      reject(err)
    })
  })
}

export default http